import { render, staticRenderFns } from "./ChartCaseList.vue?vue&type=template&id=4e1ae36b&scoped=true"
import script from "./ChartCaseList.vue?vue&type=script&lang=js"
export * from "./ChartCaseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ae36b",
  null
  
)

export default component.exports